
import BaseRadio from "@/components/base/BaseRadio.vue";
import { Insurance } from "@/models/www/Insurance";
import { InsurancePassengerState } from "@/models/www/store/InsuranceState";
import { useInsuranceStore } from "@/store/insurance";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, PropType, reactive } from "vue";

export default defineComponent({
	components: {
		BaseRadio
	},
	props: {
		insurance: {
			type: Object as PropType<Insurance>,
			required: true
		}
	},
	setup(props) {
		const insuranceStore = useInsuranceStore();

		const extendInsuranceInput = computed({
			get(): boolean {
				return insuranceStore.getPassengers.filter(p => props.insurance.passengers
																				.map(i => i.id === p.id).length > 0)
																				.length > 0;
			},
			set(value: boolean) {
				if(value) {
					props.insurance.passengers.forEach(passenger => {
						insuranceStore.addPassenger({
							...passenger
						} as InsurancePassengerState);
					});				
				}
				else {
					props.insurance.passengers.forEach(passenger => {
						insuranceStore.removePassenger(passenger.id);
					});		
				}
			}
		});

		const state = reactive({
			extendInsurance: extendInsuranceInput.value
		});

		const rules = {
			extendInsurance: {
				v: helpers.withMessage(
					() => "Please select",
					() => (extendInsuranceInput.value !== undefined) as any
				),
			}
		};

		const v$ = useVuelidate(rules, state);

		return { v$, extendInsuranceInput }
	}
})
